function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.5 4h17V1.5h-17V4zM0 1.5C0 1.1.15.75.45.45.75.15 1.1 0 1.5 0h17c.4 0 .75.15 1.05.45.3.3.45.65.45 1.05v5.975H1.5V14.5h5.825V16H1.5c-.4 0-.75-.15-1.05-.45-.3-.3-.45-.65-.45-1.05v-13zM12.95 18L8.7 13.75l1.075-1.075 3.175 3.175 6-6 1.05 1.1L12.95 18zM1.5 1.5v13-3.95 3.25V1.5z",
  fill: "currentColor"
});
var SvgChangePaymentMethod = function SvgChangePaymentMethod(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 18",
    fill: "none"
  }, props), _ref);
};
export default SvgChangePaymentMethod;